import { useCommonMenuList } from "./useCommonMenuList";

export const ServiceSidebarHooks = {
  useCommonMenuList,
};
